module.exports = __webpack_public_path__ + "static/media/motorencapsulado.ee20213e.jpg";